import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useMediaQuery } from "react-responsive";

const AssignCode = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.user_type;
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    if (location.state !== null) {
      if (is_alert === false) {
        toast.success(location.state);
      }
      is_alert = true;
    }
    window.history.replaceState({}, location.state);
  }, []);

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const monthQuery = monthFilter ? `&month=${monthFilter}` : "";

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const AssignCodeData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/orders/pagination?page=${page}&search=${search}&status=${statusFilter}&month=${monthFilter}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        const allData = res?.data?.data?.orders || [];

        // Filter orders that have at least one assignedOrder with status "approved"
        const filteredData = allData.filter((order) => {
          return (
            order.assignedOrders &&
            order.assignedOrders.some(
              (assigned) => assigned.status === "approved"
            )
          );
        });

        // Calculate actual total pages based on filtered data
        const itemsPerPage = 10; // or get this from API response
        // This is an estimate - for accurate count you'd need server-side filtering
        const estimatedTotalPages = Math.ceil(
          filteredData.length / itemsPerPage
        );

        setTotalPage(estimatedTotalPages);
        setData(filteredData);
      })
      .catch((err) => {
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export.");
      return;
    }

    // Format data for export - include only approved assigned orders
    const exportData = data.flatMap((order) =>
      order.assignedOrders
        .filter((assigned) => assigned.status === "approved")
        .map((assigned) => ({
          "Order ID": order.order_id,
          "Product Name": order.title,
          "Supplier ID": assigned.supplier_id,
          "Supplier Name": assigned.supplier_name,
          "Quotation Price": assigned.quotation_price,
          "Final Price": assigned.final_price,
          Status: assigned.status,
          "Created At": formatDateTime(assigned.created_at),
          "Customer Name": order.user?.name,
          "Customer Email": order.user?.email,
          "Customer Phone": order.user?.phone,
        }))
    );

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Approved Orders");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, "approved-assigned-orders.xlsx");
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(
            `${process.env.REACT_APP_URL}/admin/assigned-orders/change-status`,
            {
              id: id,
              status: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res?.status === 200) {
              toast.success(res?.data?.message);
              AssignCodeData();
            }
          })
          .catch((err) => {
            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err?.response?.data?.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  useEffect(() => {
    AssignCodeData();
  }, [page, search, statusFilter, monthFilter]);

  const renderStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return <span className="badge badge-warning">Pending</span>;
      case "approved":
        return <span className="badge badge-success">Approved</span>;
      case "rejected":
        return <span className="badge badge-danger">Rejected</span>;
      case "waiting_for_final_approval":
        return (
          <span className="badge badge-info">Waiting for Final Approval</span>
        );
      default:
        return <span className="badge badge-secondary">{status}</span>;
    }
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const initialsOf = (name = "") =>
    name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
  const TINTS = [
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tint = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const money = (v) => (v || v === 0) && v !== null && v !== "" ? `₹${Number(v).toLocaleString("en-IN")}` : "N/A";
  const statusMeta = (st = "") => {
    switch (st) {
      case "approved": return { label: "Approved", bg: "var(--color-success-bg)", color: "var(--color-success-text)" };
      case "pending": return { label: "Pending", bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" };
      case "rejected": return { label: "Rejected", bg: "var(--color-danger-bg)", color: "var(--color-danger-text)" };
      case "waiting_for_final_approval": return { label: "Waiting for Final Approval", bg: "var(--color-info-bg)", color: "var(--color-info-text)" };
      default: return { label: st, bg: "var(--color-surface-2)", color: "var(--color-text-secondary)" };
    }
  };

  const [dense, setDense] = useState(false);

  const rows = (data || []).flatMap((order) =>
    (order.assignedOrders || [])
      .filter((assigned) => assigned.status === "approved")
      .map((assigned) => ({ order, assigned }))
  );

  const viewState = (order, assigned) => ({
    state: {
      id: assigned.order_assigned_id,
      supplier_id: assigned.supplier.user_id,
      product_id: order.product_id,
      order_id: order.order_id,
      supplier_name: assigned.supplier.name,
      product_name: order.product.title,
      is_active: assigned.is_active,
      status: assigned.status,
      material_color: order.product.material_color,
      orderStatus: order.order_status,
      print_coverage: order.product.print_coverage,
      size: order.product.size,
      created_at: assigned.created_at,
      quotation_price: assigned.quotation_price,
      final_price: assigned.final_price,
      user: order.user,
      product: order.product,
      supplier: assigned.supplier,
      remark: assigned.supplier_to_admin_quotation_description,
      adminquotationPrice: assigned.admin_quotation_price,
    },
  });

  const ViewBtn = ({ order, assigned }) => (
    <div className="al-actions">
      <button type="button" className="al-act" title="View"
        onClick={() => Navigate("/admin/assign-order/show", viewState(order, assigned))}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      </button>
    </div>
  );

  const GRID = { gridTemplateColumns: "80px 80px 1.2fr 1.3fr 1.1fr 1.1fr .9fr 1fr 100px" };

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Assigned Orders</h1>
          <p className="al-sub">Supplier assignments per order with quotation and status.</p>
        </div>
        <div className="al-head__actions">
          {userType === "admin" && (
            <button type="button" className="al-btn al-btn--primary" onClick={exportToExcel}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Export
            </button>
          )}
        </div>
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search by order ID, product title…"
              onKeyDown={(e) => { if (e.key === "Enter") { setPage(1); AssignCodeData(); } }}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="al-select">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <select value={monthFilter} onChange={(e) => { setMonthFilter(e.target.value); setPage(1); }}>
              <option value="">Select Month</option>
              <option value="All">All</option>
              <option value="1">Last 1 Month</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
            </select>
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        {!isMobile ? (
          <div className="al-tablewrap">
            <div style={{ minWidth: 1120, "--al-row-pad": dense ? "8px" : "13px" }}>
              <div className="al-thead" style={GRID}>
                <span className="al-th">Order Id</span>
                <span className="al-th">Supplier Id</span>
                <span className="al-th">Supplier Name</span>
                <span className="al-th">Product Name</span>
                <span className="al-th">Supplier Quotation Price</span>
                <span className="al-th">Quotation for Buyer</span>
                <span className="al-th">Status</span>
                <span className="al-th">Date &amp; Time</span>
                <span className="al-th al-th--right">Action</span>
              </div>

              {rows.length > 0 ? (
                rows.map(({ order, assigned }) => {
                  const t = tint(assigned.supplier_name);
                  const sm = statusMeta(assigned.status);
                  return (
                    <div className="al-row" style={GRID} key={`${order.order_id}-${assigned.order_assigned_id}`}>
                      <span className="al-mono" style={{ color: "var(--color-primary)", fontWeight: 700 }}>#{order.order_id}</span>
                      <span className="al-mono al-muted">{assigned.supplier_id}</span>
                      <div className="al-id">
                        <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(assigned.supplier_name)}</span>
                        <span className="al-name">{assigned.supplier_name}</span>
                      </div>
                      <span className="al-muted al-ellipsis" title={order.title}>{order.title}</span>
                      <span className="al-mono" style={{ fontWeight: 700 }}>{money(assigned.quotation_price)}</span>
                      <span className="al-mono" style={{ fontWeight: 700, color: "var(--color-primary)" }}>{money(assigned.final_price)}</span>
                      <span>
                        <span className="al-pill" style={{ background: sm.bg, color: sm.color }}>{sm.label}</span>
                      </span>
                      <span className="al-mono al-muted">{formatDateTime(assigned.created_at)}</span>
                      <ViewBtn order={order} assigned={assigned} />
                    </div>
                  );
                })
              ) : (
                <div className="al-empty">
                  <div className="al-empty__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                  </div>
                  <p className="al-empty__title">No Approved Orders Found</p>
                  <p className="al-empty__text">Approved supplier assignments will appear here.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="al-mobile">
            {rows.length > 0 ? (
              rows.map(({ order, assigned }) => {
                const t = tint(assigned.supplier_name);
                const sm = statusMeta(assigned.status);
                return (
                  <div className="al-mcard" key={`${order.order_id}-${assigned.order_assigned_id}`}>
                    <div className="al-mcard__top">
                      <span className="al-avatar" style={{ background: t.bg, color: t.color }}>{initialsOf(assigned.supplier_name)}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="al-name">{assigned.supplier_name}</div>
                        <div className="al-mono al-muted" style={{ fontSize: 11 }}>Order #{order.order_id}</div>
                      </div>
                      <span className="al-pill" style={{ background: sm.bg, color: sm.color }}>{sm.label}</span>
                    </div>
                    <div className="al-mrow"><span className="al-muted">Supplier Id</span><span className="al-mono">{assigned.supplier_id}</span></div>
                    <div className="al-mrow"><span className="al-muted">Product</span><span>{order.title}</span></div>
                    <div className="al-mrow"><span className="al-muted">Supplier Quote</span><span className="al-mono">{money(assigned.quotation_price)}</span></div>
                    <div className="al-mrow"><span className="al-muted">Quotation for Buyer</span><span className="al-mono" style={{ color: "var(--color-primary)" }}>{money(assigned.final_price)}</span></div>
                    <div className="al-mrow"><span className="al-muted">Date</span><span className="al-mono al-muted">{formatDateTime(assigned.created_at)}</span></div>
                    <div className="al-mactions"><ViewBtn order={order} assigned={assigned} /></div>
                  </div>
                );
              })
            ) : (
              <div className="al-empty"><p className="al-empty__title">No Approved Orders Found</p></div>
            )}
          </div>
        )}

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{rows.length}</strong> assignments</span>
          {data?.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignCode;
